import { useState } from 'react'
import { customerData } from '../utilities/CustomerData'
import { useNavigate } from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.module.css'
import { Calendar, DateObject } from 'react-multi-date-picker'
import DatePanel from 'react-multi-date-picker/plugins/date_panel'

import '../css/Slider.css'

export default function SpouseCalculation({ setReload }) {
  const navigate = useNavigate()
  const [noTaxCreditGovJanuary, setNoTaxCreditGovJanuary] = useState(false)
  const [taxCreditGovJanuary, setTaxCreditGovJanuary] = useState([])

  const [noTaxCreditGovApril, setNoTaxCreditGovApril] = useState(false)
  const [taxCreditGovApril, setTaxCreditGovApril] = useState([])

  const [noTaxCreditChildJanuary, setNoTaxCreditChildJanuary] = useState(false)
  const [taxCreditChildJanuary, setTaxCreditChildJanuary] = useState([])

  const [noTaxCreditChildApril, setNoTaxCreditChildApril] = useState(false)
  const [taxCreditChildApril, setTaxCreditChildApril] = useState([])

  const [childUnder18, setChildUnder18] = useState('')
  const [taxCreditFamilyJanuary, setTaxCreditFamilyJanuary] = useState(0)
  const [taxCreditFamilyApril, setTaxCreditFamilyApril] = useState(0)
  const [claimingDependents, setClaimingDependents] = useState('')

  const [submittingSpouseDays, setSubmittingSpouseDays] = useState(false)
  const [error, setError] = useState(false)
  const [submittedSpouseDays, setSubmittedSpouseDays] = useState(false)

  const handleSubmitSpouseDays = async () => {
    setSubmittingSpouseDays(true)
    
    const calculateSpouseDaysResponse = await fetch('https://myportal.setcpros.com/calculator/api/calculateSpouseDays', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        leadId: customerData.customerLeadData.leadId,
        taxCreditGovJanuary: taxCreditGovJanuary,
        taxCreditGovApril: taxCreditGovApril,
        taxCreditChildJanuary: taxCreditChildJanuary,
        taxCreditChildApril: taxCreditChildApril,
        taxCreditFamilyJanuary: taxCreditFamilyJanuary,
        taxCreditFamilyApril: taxCreditFamilyApril,
      })
    })
    const calculateSpouseDaysData = await calculateSpouseDaysResponse.json()
    setSubmittedSpouseDays(true)
    if(calculateSpouseDaysData.response.error)
      setError(true)
  }

  return (
    <div className='p-4 w-screen h-fit mt-10 flex flex-col mb-10 items-center'>
      {!submittingSpouseDays ? (
        <div className='max-w-4xl flex flex-col items-center'>
          <div className='flex flex-col items-start gap-3 mb-10'>
            <p className='font-bold text-xl'>Sick Leave Tax Credit (You)</p>
            <div className='w-full border-t border-gray-300'></div>
            <p className='text-gray-600 text-sm'>How many days were you unable to work due to government shutdowns, quarantine, isolation orders, and/or a COVID-19 diagnosis or symptoms?</p>
          </div>
          <div className='w-full gap-4'>
            <div className='mb-10'>
              <p className='font-bold mb-4'>Select up to 10 days between January 1, 2021, and March 31, 2021</p>
              <div className='flex flex-row max-sm:flex-col lg:items-center gap-4'>
                <div className='w-full flex justify-center'>
                  <Calendar
                    className='custom-calendar'
                    value={taxCreditGovJanuary}
                    onChange={(e) => {
                      const newDates = e.map((date) => date.format())

                      if (newDates.length <= 10)
                        setTaxCreditGovJanuary(newDates)
                      else {
                        newDates.pop()
                        setTaxCreditGovJanuary(newDates)
                      }
                    }}
                    multiple
                    sort
                    format='YYYY-MM-DD'
                    minDate='2021-01-01'
                    maxDate='2021-03-31'
                    currentDate={new DateObject({
                      year: 2021,
                      month: 1,
                      day: 1
                    })}
                    plugins={[
                      <DatePanel />
                    ]}
                  >
                    <div className='w-full flex flex-col items-center'>
                      <p className='w-3/4 self-center text-xs italic'>Press any of the dates to select/deselect them</p>
                      <div className='w-full flex flex-row justify-center gap-4 self-center mt-4'>
                        <button onClick={() => setTaxCreditGovJanuary([])} className='rounded-md px-4 py-2 mb-4 bg-white hover:bg-gray-100'>
                          Clear
                        </button>
                      </div>
                    </div>
                  </Calendar>
                </div>
                <div className='w-full'>
                  <div onClick={() => {
                    setTaxCreditGovJanuary([])
                    setNoTaxCreditGovJanuary(!noTaxCreditGovJanuary)

                    if (noTaxCreditGovJanuary)
                      setTaxCreditGovJanuary(taxCreditGovJanuary)
                  }} className='flex flex-row items-center gap-2 mb-4 cursor-pointer'>
                    <input
                      type='checkbox'
                      checked={noTaxCreditGovJanuary}
                      onChange={(e) => {
                        setTaxCreditGovJanuary([])
                        setNoTaxCreditGovJanuary(e.target.checked)

                        if (!e.target.checked)
                          setTaxCreditGovJanuary(taxCreditGovJanuary)
                      }}
                    />
                    <p className='font-bold text-gray-500'>No Days</p>
                  </div>
                  <p className='text-gray-500'>You have selected <span className='font-bold'>{taxCreditGovJanuary.length} out of 10 days</span></p>
                </div>
              </div>
            </div>
          </div>
          <div className='w-full gap-4'>
              <div className='mb-10'>
                <p className='font-bold mb-4'>Select up to 10 days between April 1, 2021 and September 30, 2021</p>
                <div className='flex flex-row max-sm:flex-col lg:items-center gap-4'>
                  <div className='w-full flex justify-center'>
                    <Calendar
                      className='custom-calendar'
                      value={taxCreditGovApril}
                      onChange={(e) => {
                        const newDates = e.map((date) => date.format())

                        if (newDates.length <= 10)
                          setTaxCreditGovApril(newDates)
                        else {
                          newDates.pop()
                          setTaxCreditGovApril(newDates)
                        }
                      }}
                      multiple
                      sort
                      format='YYYY-MM-DD'
                      minDate='2021-04-01'
                      maxDate='2021-09-30'
                      currentDate={new DateObject({
                        year: 2021,
                        month: 4,
                        day: 1
                      })}
                      plugins={[
                        <DatePanel />
                      ]}
                    >
                      <div className='w-full flex flex-col items-center'>
                        <p className='w-3/4 self-center text-xs italic'>Press any of the dates to select/deselect them</p>
                        <div className='w-full flex flex-row justify-center gap-4 self-center mt-4'>
                          <button onClick={() => setTaxCreditGovApril([])} className='rounded-md px-4 py-2 mb-4 bg-white hover:bg-gray-100'>
                            Clear
                          </button>
                        </div>
                      </div>
                    </Calendar>
                  </div>
                  <div className='w-full'>
                    <div onClick={() => {
                      setTaxCreditGovApril([])
                      setNoTaxCreditGovApril(!noTaxCreditGovApril)
    
                      if (noTaxCreditGovApril)
                        setTaxCreditGovApril(taxCreditGovJanuary)
                    }} className='flex flex-row items-center gap-2 mb-4 cursor-pointer'>
                      <input
                        type='checkbox'
                        checked={noTaxCreditGovApril}
                        onChange={(e) => {
                          setTaxCreditGovApril([])
                          setNoTaxCreditGovApril(e.target.checked)
    
                          if (!e.target.checked)
                            setTaxCreditGovApril(taxCreditGovJanuary)
                        }}
                      />
                      <p className='font-bold text-gray-500'>No Days</p>
                    </div>
                    <p className='text-gray-500'>You have selected <span className='font-bold'>{taxCreditGovApril.length} out of 10 days</span></p>
                  </div>
                </div>
              </div>
            </div>
          <div className='flex flex-col items-start gap-3 mb-10'>
            <p className='font-bold text-xl'>Sick Leave Tax Credit (Someone Else)</p>
            <div className='w-full border-t border-gray-300'></div>
            <p className='text-gray-600 text-sm'>How many days were you unable to work caring for: (1) anyone subject to government ordered or medically advised quarantine related to COVID-19, and/or (2) a child whose school or place of care was closed due to COVID-19?</p>
          </div>
          <div className='w-full gap-4'>
            <div className='mb-10'>
              <p className='font-bold mb-4'>Select up to 10 days between January 1, 2021, and March 31, 2021</p>
              <div className='flex flex-row max-sm:flex-col lg:items-center gap-4'>
                <div className='w-full flex justify-center'>
                  <Calendar
                    className='custom-calendar'
                    value={taxCreditChildJanuary}
                    onChange={(e) => {
                      const newDates = e.map((date) => date.format())
                      const alreadyContainsDate = newDates.some(date => taxCreditGovJanuary.includes(date))
                      if (alreadyContainsDate) return false

                      if (newDates.length <= (10 - taxCreditGovJanuary.length))
                        setTaxCreditChildJanuary(newDates)
                      else {
                        newDates.pop()
                        setTaxCreditChildJanuary(newDates)
                      }
                    }}
                    multiple
                    sort
                    format='YYYY-MM-DD'
                    minDate='2021-01-01'
                    maxDate='2021-03-31'
                    mapDays={({ date }) => {
                      let className
                      const strDate = date.format()
                      if (taxCreditGovJanuary.includes(strDate)) className = 'bg-[#f0f0f0] text-[#a0a0a0] opacity-[0.6]'
                      if (className) return { className }
                    }}
                    currentDate={new DateObject({
                      year: 2021,
                      month: 1,
                      day: 1
                    })}
                    plugins={[
                      <DatePanel />
                    ]}
                  >
                    <div className='w-full flex flex-col items-center'>
                      <p className='w-3/4 self-center text-xs italic'>Press any of the dates to select/deselect them</p>
                      <div className='w-full flex flex-row justify-center gap-4 self-center mt-4'>
                        <button onClick={() => setTaxCreditChildJanuary([])} className='rounded-md px-4 py-2 mb-4 bg-white hover:bg-gray-100'>
                          Clear
                        </button>
                      </div>
                    </div>
                  </Calendar>
                </div>
                <div className='w-full'>
                  <div onClick={() => {
                    setTaxCreditChildJanuary([])
                    setNoTaxCreditChildJanuary(!noTaxCreditChildJanuary)

                    if (noTaxCreditChildJanuary)
                      setTaxCreditChildJanuary(taxCreditGovJanuary)
                  }} className='flex flex-row items-center gap-2 mb-4 cursor-pointer'>
                    <input
                      type='checkbox'
                      checked={noTaxCreditChildJanuary}
                      onChange={(e) => {
                        setTaxCreditChildJanuary([])
                        setNoTaxCreditChildJanuary(e.target.checked)

                        if (!e.target.checked)
                          setTaxCreditChildJanuary(taxCreditGovJanuary)
                      }}
                    />
                    <p className='font-bold text-gray-500'>No Days</p>
                  </div>
                  <p className='text-gray-500'>You have selected <span className='font-bold'>{taxCreditChildJanuary.length} out of {10 - taxCreditGovJanuary.length} days</span></p>
                </div>
              </div>
            </div>
          </div>
          <div className='w-full gap-4'>
            <div className='mb-10'>
            <p className='font-bold mb-4'>Select up to 10 days between April 1, 2021 and September 30, 2021</p>
              <div className='flex flex-row max-sm:flex-col lg:items-center gap-4'>
                <div className='w-full flex justify-center'>
                  <Calendar
                    className='custom-calendar'
                    value={taxCreditChildApril}
                    onChange={(e) => {
                      const newDates = e.map((date) => date.format())

                      const alreadyContainsDate = newDates.some(date => taxCreditGovJanuary.includes(date))
                      if (alreadyContainsDate) return false

                      if (newDates.length <= (10 - taxCreditGovApril.length))
                        setTaxCreditChildApril(newDates)
                      else {
                        newDates.pop()
                        setTaxCreditChildApril(newDates)
                      }
                    }}
                    multiple
                    sort
                    format='YYYY-MM-DD'
                    mapDays={({ date }) => {
                      let className
                      const strDate = date.format()
                      if (taxCreditGovApril.includes(strDate)) className = 'bg-[#f0f0f0] text-[#a0a0a0] opacity-[0.6]'
                      if (className) return { className }
                    }}
                    minDate='2021-04-01'
                    maxDate='2021-09-30'
                    currentDate={new DateObject({
                      year: 2021,
                      month: 4,
                      day: 1
                    })}
                    plugins={[
                      <DatePanel />
                    ]}
                  >
                    <div className='w-full flex flex-col items-center'>
                      <p className='w-3/4 self-center text-xs italic'>Press any of the dates to select/deselect them</p>
                      <div className='w-full flex flex-row justify-center gap-4 self-center mt-4'>
                        <button onClick={() => setTaxCreditChildApril([])} className='rounded-md px-4 py-2 mb-4 bg-white hover:bg-gray-100'>
                          Clear
                        </button>
                      </div>
                    </div>
                  </Calendar>
                </div>
                <div className='w-full'>
                  <div onClick={() => {
                    setTaxCreditChildApril([])
                    setNoTaxCreditChildApril(!noTaxCreditChildApril)

                    if (noTaxCreditChildApril)
                      setTaxCreditChildApril(taxCreditGovJanuary)
                  }} className='flex flex-row items-center gap-2 mb-4 cursor-pointer'>
                    <input
                      type='checkbox'
                      checked={noTaxCreditChildApril}
                      onChange={(e) => {
                        setTaxCreditChildApril([])
                        setNoTaxCreditChildApril(e.target.checked)

                        if (!e.target.checked)
                          setTaxCreditChildApril(taxCreditGovJanuary)
                      }}
                    />
                    <p className='font-bold text-gray-500'>No Days</p>
                  </div>
                  <p className='text-gray-500'>You have selected <span className='font-bold'>{taxCreditChildApril.length} out of {10 - taxCreditGovApril.length} days</span></p>
                </div>
              </div>
            </div>
          </div>
          <div className='w-full flex flex-col items-start gap-3'>
            <p className='font-bold text-xl'>Family Leave Tax Credit</p>
            <div className='w-full border-t border-gray-300'></div>
            <p className='text-gray-600 text-sm'>How many days were you unable to work caring for: (1) anyone subject to government ordered or medically advised quarantine related to COVID-19, and/or (2) a child whose school or place of care was closed due to COVID-19?</p>
            <div className='w-full flex flex-col items-center justify-center'>
              <p>Did you take care of a child under the age of 18 in 2021?</p>
              <div className='flex flex-row items-center gap-4 mt-2 mb-10'>
                <button onClick={() => setChildUnder18('Yes')} className={`w-24 py-2 ${childUnder18 === 'Yes' ? 'bg-primaryDarkColor text-white' : 'hover:bg-primaryColor hover:text-white border-[1px] text-black'} rounded-md`}>
                  Yes
                </button>
                <button onClick={() => { setChildUnder18('No'); setTaxCreditFamilyJanuary(0); setTaxCreditFamilyApril(0) }} className={`w-24 py-2 ${childUnder18 === 'No' ? 'bg-primaryDarkColor text-white' : 'hover:bg-primaryColor hover:text-white border-[1px] text-black'} rounded-md`}>
                  No
                </button>
              </div>
            </div>
            {childUnder18 === 'Yes' && (
              <div className='w-full flex flex-col items-center mb-10'>
                <p className='mt-4'>January 1, 2021 through March 31, 2021 <span className='font-bold'>(50 Days Max)</span></p>
                <div className='w-full flex flex-col items-center mt-4'>
                  <div className='mb-2'>
                    <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                      {taxCreditFamilyJanuary} days
                    </span>
                  </div>
                  <div className='w-full relative flex items-center gap-4'>
                    <span className='text-gray-700 text-nowrap'>0 days</span>
                    <input
                      type='range'
                      id='dateSlider'
                      min='0'
                      max='50'
                      step='1'
                      value={taxCreditFamilyJanuary}
                      onChange={(e) => setTaxCreditFamilyJanuary(Number(e.target.value))}
                      className='w-full h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                      style={{
                        background: `linear-gradient(to right, #74be43 ${((taxCreditFamilyJanuary / 50) * 100)}%, #ddd ${((taxCreditFamilyJanuary / 50) * 100)}%)`,
                      }}
                    />
                    <span className='text-gray-700 text-nowrap'>50 days</span>
                  </div>
                </div>
                <p className='mt-10'>April 1, 2021 through September 30, 2021 <span className='font-bold'>(60 Days Max)</span></p>
                <div className='w-full flex flex-col items-center mt-4'>
                  <div className='mb-2'>
                    <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                      {taxCreditFamilyApril} days
                    </span>
                  </div>
                  <div className='w-full relative flex items-center gap-4 text-nowrap'>
                    <span className='text-gray-700'>0 days</span>
                    <input
                      type='range'
                      id='dateSlider'
                      min='0'
                      max='60'
                      step='1'
                      value={taxCreditFamilyApril}
                      onChange={(e) => setTaxCreditFamilyApril(Number(e.target.value))}
                      className='w-full h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                      style={{
                        background: `linear-gradient(to right, #74be43 ${((taxCreditFamilyApril / 60) * 100)}%, #ddd ${((taxCreditFamilyApril / 60) * 100)}%)`,
                      }}
                    />
                    <span className='text-gray-700 text-nowrap'>60 days</span>
                  </div>
                </div>
                <div className='flex flex-col items-center mb-10 gap-4 mt-10 text-sm'>
                  <p>Your response to the previous question regarding days you were unable to work because of coronavirus-related care you provided to a <strong>SON</strong> or <strong>DAUGHTER</strong> indicated that you did, in fact, claim one or more such days. Please note, the IRS is actively evaluating these claims and only granting this portion of the credit to filers who have a qualifying dependent child on record for tax year 2021.</p>
                  <label className="flex items-center space-x-2">
                    <input 
                      type="checkbox" 
                      name="claimedDependent" 
                      checked={claimingDependents === 'Yes'}
                      onChange={() => setClaimingDependents('Yes')}
                      className="w-5 h-5 text-primaryColor focus:ring-primaryColor"
                    />
                    <span>Yes, I claimed my son or daughter as a dependent on my originally filed 2021 Form 1040.</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input 
                      type="checkbox" 
                      name="claimedDependent" 
                      checked={claimingDependents === 'No'}
                      onChange={() => setClaimingDependents('No')}
                      className="w-5 h-5 text-primaryColor focus:ring-primaryColor"
                    />
                    <span>No, I did not claim my son or daughter as a dependent on my originally filed 2021 Form 1040. Please process my credit without those days included.</span>
                  </label>
                </div>
              </div>
            )}
          </div>
          <button 
            onClick={handleSubmitSpouseDays}
            disabled={(!noTaxCreditGovJanuary && taxCreditGovJanuary.length === 0) || (!noTaxCreditGovApril && taxCreditGovApril.length === 0) || (!noTaxCreditChildJanuary && taxCreditChildJanuary.length === 0 && taxCreditGovJanuary.length === 9) || (!noTaxCreditChildApril && taxCreditChildApril.length === 0 && taxCreditGovApril.length === 9) || !childUnder18}
            className={`rounded-md text-white h-10 px-4 mb-4 ${(!noTaxCreditGovJanuary && taxCreditGovJanuary.length === 0) || (!noTaxCreditGovApril && taxCreditGovApril.length === 0) || (!noTaxCreditChildJanuary && taxCreditChildJanuary.length === 0 && taxCreditGovJanuary.length === 9) || (!noTaxCreditChildApril && taxCreditChildApril.length === 0 && taxCreditGovApril.length === 9) || !childUnder18 ? 'bg-gray-400' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}>
            Submit Spouse Days
          </button>
        </div>
      ) : (
        !submittedSpouseDays ? (
          <div className='max-w-lg max-sm:w-11/12 flex flex-col items-center shadow-lg rounded-md p-8 gap-4'>
            <p className='text-lg font-semibold text-center'>Calculating Refund</p>
            <p className='text-center'>We have submitted your spouse days, and are calculating your new refund!</p>
            <div className='flex flex-row items-center justify-center gap-2'>
              <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
              <p>Please do not close or leave this window...</p>
            </div>
          </div>
        ) : (
          error ? (
            <div className='max-w-lg max-sm:w-11/12 flex flex-col items-center shadow-lg rounded-md p-8 gap-4'>
              <p className='text-lg font-semibold text-center'>Error Calculating Refund</p>
              <p className='text-center'>There seems to have been a problem calculating your new refund.</p>
              <p className='text-center'>Please come back and try again later. We apologize for this delay.</p>
              <div className='flex justify-center w-full'>
              <button
                onClick={() => { setReload(true); navigate('/') }}
                className='px-8 py-2 text-white rounded bg-primaryColor hover:bg-primaryDarkColor transition duration-200'>
                Ok
              </button>
            </div>
            </div>
          ) : (
            <div className='max-w-lg max-sm:w-11/12 flex flex-col items-center shadow-lg rounded-md p-8 gap-4'>
            <p className='text-lg font-semibold text-center'>New Refund Calculated</p>
            <p className='text-center'>Your new refund is calculated!</p>
            <p className='text-center'>Please return to your customer portal to continue your refund process.</p>
            <div className='flex justify-center w-full'>
              <button
                onClick={() => { setReload(true); navigate('/') }}
                className='px-8 py-2 text-white rounded bg-primaryColor hover:bg-primaryDarkColor transition duration-200'>
                OK
              </button>
            </div>
          </div>
          )
          
        )
      )}
    </div>
  )
}